module.exports = __webpack_public_path__ + "static/media/loader.06354ad3.svg";